import React from 'react';
import { usePackagesQuery } from '../../../lib/Queries';
import Loading from '../../Loading';
import ErrorMessageBlock from '~/components/ErrorMessageBlock';
import { Link } from 'react-router-dom';
import { getBusinessUrl } from '~/lib/useBusinessNavigate';

const EditPackagesQuestionForm = ({ settings, setSettings }) => {
    const { data, isLoading } = usePackagesQuery('');
    const packages = data?.packages || [];
    const selectedPackages = settings?.packages || [];
    const isAllSelected = !selectedPackages.length;

    function isSelected(p) {
        return !!selectedPackages.find(sp => sp === p.id);
    }

    function togglePackage(p, isChecked) {
        let newPackages = [...selectedPackages];
        if (isChecked) {
            newPackages.push(p.id);
        } else {
            newPackages = newPackages.filter(sp => sp !== p.id);
        }

        setSettings({
            ...settings,
            packages: newPackages,
        });
    }

    return (
        <div>
            {!packages.length && !isLoading && (
                <ErrorMessageBlock className="mt-4">
                    You have no packages or subscriptions. You can set these up
                    in{' '}
                    <Link
                        to={getBusinessUrl(`/packages`)}
                        className="text-white"
                    >
                        Selling &gt; Packages
                    </Link>{' '}
                    or{' '}
                    <Link
                        to={getBusinessUrl(`/subscriptions`)}
                        className="text-white"
                    >
                        Subscriptions
                    </Link>
                </ErrorMessageBlock>
            )}
            <div className="input-label mt-4">Show Packages</div>
            <div className="panel px-4 pt-2">
                <label className="flex space-x-4 items-center">
                    <input
                        type="radio"
                        checked={isAllSelected}
                        onChange={e => {
                            if (e.target.checked) {
                                setSettings({ ...settings, packages: [] });
                            }
                        }}
                    />
                    <div>All packages &amp; subscriptions</div>
                </label>
                <label className="flex space-x-4 items-center pb-2">
                    <input
                        type="radio"
                        checked={!isAllSelected}
                        onChange={e => {
                            console.log(
                                'packages = ',
                                e.target.checked,
                                packages,
                            );
                            if (e.target.checked) {
                                setSettings({
                                    ...settings,
                                    packages: packages.map(p => p.id),
                                });
                            }
                        }}
                    />
                    <div>Specific packages or subscriptions</div>
                </label>
                {!isAllSelected && (
                    <div className="ml-8">
                        {isLoading && <Loading />}
                        {packages.map(p => (
                            <label
                                key={p.id}
                                className="flex items-center space-x-4 pb-2"
                            >
                                <input
                                    type="checkbox"
                                    checked={isSelected(p)}
                                    onChange={e =>
                                        togglePackage(p, e.target.checked)
                                    }
                                />

                                <div>{p.name}</div>
                            </label>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default EditPackagesQuestionForm;
